import { useEffect, useState } from "react";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { ProofStrip } from "@/components/ProofStrip";
import { OwnersSection } from "@/components/OwnersSection";
import { DevelopersSection } from "@/components/DevelopersSection";
import { AcquirersSection } from "@/components/AcquirersSection";
import { ApproachSection } from "@/components/ApproachSection";
import { Footer } from "@/components/Footer";
import { BookingModal } from "@/components/BookingModal";
import { LeadCaptureModal } from "@/components/LeadCapture";
import { StickyCTA } from "@/components/StickyCTA";
import { ScrollProgress } from "@/components/ScrollProgress";
import { BootOverlay } from "@/components/BootOverlay";

export default function LandingPage() {
  const [bookingDoor, setBookingDoor] = useState(null);
  const [leadDoor, setLeadDoor] = useState(null);

  useEffect(() => {
    try {
      if (!window.localStorage.getItem("novare_intro_seen")) {
        setLeadDoor("general");
      }
    } catch {
      setLeadDoor("general");
    }
  }, []);

  const closeLead = () => {
    try {
      window.localStorage.setItem("novare_intro_seen", "1");
    } catch {}
    setLeadDoor(null);
  };

  const openEnquire = () => setLeadDoor("general");

  return (
    <div id="top" className="bg-[#0E1613] text-[#EDE7DA] min-h-screen pb-14 md:pb-0">
      <BootOverlay />
      <ScrollProgress />
      <Nav onBookCall={() => setBookingDoor("Owner")} onEnquire={openEnquire} />
      <Hero onBook={setBookingDoor} onLead={setLeadDoor} />
      <ProofStrip />
      <OwnersSection onBook={() => setBookingDoor("Owner")} />
      <DevelopersSection onBook={() => setBookingDoor("Developer")} />
      <AcquirersSection onBook={() => setBookingDoor("Acquirer")} />
      <ApproachSection />
      <Footer onLead={openEnquire} />
      <BookingModal door={bookingDoor} onClose={() => setBookingDoor(null)} />
      <LeadCaptureModal door={leadDoor} onClose={closeLead} />
      <StickyCTA onBook={() => setBookingDoor("Owner")} onEnquire={openEnquire} />
    </div>
  );
}
